import { Uuid } from "../../../../domain/model/uuid/uuid.type";
import { DataStoreId } from "../../data-store-id.type";
import { StoreTrialPhaseType } from "./store-trial-phase-type";

export class StoreTrialPhase implements DataStoreId {
  readonly id: string;
  readonly number: number;
  readonly type: StoreTrialPhaseType;
  readonly expectedStartDate: Date | null;
  readonly expectedEndDate: Date | null;
  readonly expectedStartWeightKg: number | null;
  readonly expectedEndWeightKg: number | null;

  constructor(
    id: Uuid,
    number: number,
    type: StoreTrialPhaseType,
    expectedStartDate: Date | null,
    expectedEndDate: Date | null,
    expectedStartWeightKg: number | null,
    expectedEndWeightKg: number | null
  ) {
    this.id = id.asString();
    this.number = number;
    this.type = type;
    this.expectedStartDate = expectedStartDate;
    this.expectedEndDate = expectedEndDate;
    this.expectedStartWeightKg = expectedStartWeightKg;
    this.expectedEndWeightKg = expectedEndWeightKg;
  }
}
